import { getText, interpolate } from "shared/lib";

import { AnalysisCallout, Button } from "shared/components";

export interface ExemptionsMayApplyCalloutProps {
  onClickPermitApplication: () => void;
}

export function ExemptionsMayApplyCallout({
  onClickPermitApplication,
}: ExemptionsMayApplyCalloutProps) {
  return (
    <AnalysisCallout
      className="bg-textWhite border-interfaceBorder border-t-1 border-r-1 border-b-1"
      title={getText("✋ Your proposal may not require a planning permit")}
      type="default"
    >
      <p>
        {interpolate(
          "Read through the exemptions listed in your proposal's {{button}}. If any apply, you may not need to submit a planning permit, and you can disregard the below.",
          {
            button: (
              <Button
                className="text-bodysm h-auto px-0 py-0 underline"
                onClick={onClickPermitApplication}
                variant="link"
              >
                {getText("permit requirements")}
              </Button>
            ),
          },
        )}
      </p>
    </AnalysisCallout>
  );
}
